import { type ReactNode } from 'react'
import { Heading, PageHeader, Text } from '#app/components/text.tsx'

/**
 * Shared shell for the privacy policy and terms of service.
 * Keeps both pages on one heading structure so the h1 -> h2 order stays valid.
 */
export function LegalPage({
	heading,
	effectiveDate,
	children,
}: {
	heading: string
	effectiveDate: string
	children: ReactNode
}) {
	return (
		<main>
			<PageHeader heading={heading} />
			<div className="container mb-24 sm:mb-32">
				<div className="max-w-prose mx-auto space-y-10">
					<Text className="text-muted-foreground">Last updated: {effectiveDate}</Text>
					{children}
				</div>
			</div>
		</main>
	)
}

export function LegalSection({
	title,
	children,
}: {
	title: string
	children: ReactNode
}) {
	return (
		<section className="space-y-4">
			<Heading as="h2" className="text-h4">
				{title}
			</Heading>
			{children}
		</section>
	)
}
